<div class="w-100 float-left">
    <h5 class="b-b pb-3 medium mb-0">{{'manageOperations'|translate}}</h5>

    <div class="w-100 float-left my-4">
        <button class="btn btn-primary float-right" (click)="addOperation()">{{'addOperation'|translate}}</button>
    </div>
    <div class="w-100 float-left">
        <div class="w-100 float-left">
            <div class="light-bg w-100 float-left p-2 grid-details">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 medium"> {{'operation'|translate}} </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 medium"> {{'name'|translate}} </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 medium"> {{'externalURL'|translate}} </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center">
                    <h6 class="mb-lg-0 medium"> {{'action'|translate}} </h6>
                </div>
            </div>

            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let operation of operationList">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{operation.operation}} </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{operation.name}} </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{operation.externalURL}} </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center">
                    <div><em class="fa fa-edit" (click)="updateOperation(operation)"></em></div>
                </div>
            </div>
        </div>

        <!-- PAGINATION -->
        <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
            <h6 class="float-left mb-0"> {{startingPage}} - {{endingPage}} {{'itemsOf'}} {{collectionSize}} </h6>
            <div class="float-left ml-2 align-v-center">
                <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
                <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                        (change)="OnPageSizeChanged($event.target.value)">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </select>
            </div>
            <div style="flex-grow: 1;"></div>
            <ngb-pagination [collectionSize]="collectionSize" [rotate]="true" [pageSize]="pageSize" [maxSize]="5"
                            [ellipses]="false"
                            [(page)]="page" [boundaryLinks]="true" (pageChange)="onPageChange($event)"
                            class="float-right"></ngb-pagination>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/operations/manageOperation.component.html